import { useEffect, useRef } from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from 'root/src/client/v2/trpc/trpc';
// The creators leaderboard (server-paginated) via the existing tRPC procedure. `keepPreviousData`
// keeps the current page while the next fetches, but when the RANKING TYPE changes we report loading
// (not the kept rows) so the previous ranking's creators never show under the new tab.
export const useLeaderboard = ({ page, pageSize, rankingType }) => {
    var _a, _b;
    const query = trpc.creatorDashboard.getCreatorsLeaderboard.useQuery({ currentPage: page, limit: pageSize, rankingType }, { placeholderData: keepPreviousData, staleTime: 30000 });
    const data = query.data;
    const loadedRanking = useRef(rankingType);
    useEffect(() => {
        if (!query.isPlaceholderData) {
            loadedRanking.current = rankingType;
        }
    }, [query.isPlaceholderData, rankingType]);
    const rankingIsStale = query.isPlaceholderData && loadedRanking.current !== rankingType;
    return {
        creators: ((_a = data === null || data === void 0 ? void 0 : data.creators) !== null && _a !== void 0 ? _a : []),
        pageCount: Math.max(1, (_b = data === null || data === void 0 ? void 0 : data.allPage) !== null && _b !== void 0 ? _b : 1),
        isLoading: query.isLoading || rankingIsStale,
        isFetching: query.isFetching,
        isError: query.isError,
    };
};
